import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import { ListItem } from 'react-toolbox/lib/list'
import { Link } from 'react-router-dom'

import styles from './styles.scss'

const NavigationListItem = (props) => {
  const { to, label, onClick } = props
  return (
    <Link to={to}>
      <ListItem onClick={onClick} theme={styles} rightIcon='chevron_right' caption={label}/>
    </Link>
  )
}

NavigationListItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
}

NavigationListItem.defaultProps = {
  to: '/',
  label: '',
}

export default CSSModules(styles, NavigationListItem)
